import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
  getActiveUsers,
  getRegisteredUsers,
  getTopEvents,
  getFeatureAdoption,
  getNewVsReturning,
  getActivationFunnel,
  getCohorts,
} from '@/api/analyticsService';
import { queryKeys } from '@/lib/queryKeys';

const isNotConfigured = (error: unknown): boolean =>
  (error as AxiosError)?.response?.status === 503;

const posthogQueryOptions = {
  refetchInterval: 10 * 60 * 1000,
  retry: (failureCount: number, error: unknown) =>
    !isNotConfigured(error) && failureCount < 2,
};

export const useAdminAnalytics = () => {
  const activeUsers = useQuery({
    queryKey: queryKeys.analyticsActiveUsers,
    queryFn: getActiveUsers,
    ...posthogQueryOptions,
  });

  const registeredUsers = useQuery({
    queryKey: queryKeys.analyticsRegisteredUsers,
    queryFn: getRegisteredUsers,
    refetchInterval: 10 * 60 * 1000,
  });

  const topEvents = useQuery({
    queryKey: queryKeys.analyticsTopEvents,
    queryFn: getTopEvents,
    ...posthogQueryOptions,
  });

  const featureAdoption = useQuery({
    queryKey: queryKeys.analyticsFeatureAdoption,
    queryFn: getFeatureAdoption,
    ...posthogQueryOptions,
  });

  const newVsReturning = useQuery({
    queryKey: queryKeys.analyticsNewVsReturning,
    queryFn: getNewVsReturning,
    ...posthogQueryOptions,
  });

  const activationFunnel = useQuery({
    queryKey: queryKeys.analyticsActivationFunnel,
    queryFn: getActivationFunnel,
    ...posthogQueryOptions,
  });

  const cohorts = useQuery({
    queryKey: queryKeys.analyticsCohorts,
    queryFn: getCohorts,
    ...posthogQueryOptions,
  });

  const posthogConfigured = !isNotConfigured(activeUsers.error);

  return {
    posthogConfigured,
    activeUsers,
    registeredUsers,
    topEvents,
    featureAdoption,
    newVsReturning,
    activationFunnel,
    cohorts,
  };
};
